import { render } from "./OutlayRow.vue?vue&type=template&id=92f6476e&scoped=true"
import script from "./OutlayRow.vue?vue&type=script&lang=js"
export * from "./OutlayRow.vue?vue&type=script&lang=js"

import "./OutlayRow.vue?vue&type=style&index=0&id=92f6476e&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f6476e"]])

export default __exports__